export default __webpack_public_path__ + "static/media/qr_code_2.ec77ceaa.jpg";